import React from 'react';
import styled from 'styled-components';
import MetaDataItemValue from './components/MetaDataValue';

export const MetadataValuesList = styled.ul`
    margin: 0;
    list-style: none;
    padding: 0;
`;

const MetaDataValuesList = ({ name, opened, metadataValues, labelIndex, ...rest }) => (
    <MetadataValuesList {...{ className: 'accordion-list__nested-list' }} {...rest}>
        {metadataValues.map((metaDataItem, i) => (
            <MetaDataItemValue
                name={name}
                opened={opened}
                metaDataItem={metaDataItem}
                index={`${name}-${i}`}
                key={i}
                labelIndex={labelIndex}
                valuePosition={i}
                numOfExtractions={metadataValues.length}
            />
        ))}
    </MetadataValuesList>
);

export default MetaDataValuesList;
